import VillersAugust2026 from "../../components/before-after/VillersAugust2026";

const VillersAugust2026View = () => {

    return (
        <div className="before-after-villers-august-2026">
            <VillersAugust2026/>
        </div>
    );
};

export default VillersAugust2026View;
